import { AutojobSearchFilter } from 'src/modules/dashboard/models/autojobsSearchFilter';
import { AutojobResponse } from 'src/modules/dashboard/models/autojobResponse';
import AxiosInstance from './axios/interceptor';
import { PagedResult } from '../models/pagedResult';

const controller = 'Autojob';

// export const getLatestAutojobs = (options: AutojobSearchFilter) => {
//   const endpoint = `${controller}/Latest`;
//   return AxiosInstance.get<PagedResult<AutojobResponse>>(endpoint, { params: options });
// };
// export const getUpcomingAutojobs = (options: AutojobSearchFilter) => {
//   const endpoint = `${controller}/Upcoming`;
//   return AxiosInstance.get<PagedResult<AutojobResponse>>(endpoint, { params: options });
// };
export const getAllAutojobs = (options: AutojobSearchFilter) => {
  const endpoint = `${controller}`;
  return AxiosInstance.get<PagedResult<AutojobResponse>>(endpoint, { params: options });
};
export const getAutojobById = (id: number | undefined) => {
  return AxiosInstance.get<AutojobResponse>(`${controller}/${id}`);
};
